var render = function render(){var _vm=this,_c=_vm._self._c;return _c('multiselect',{attrs:{"options":_vm.grades,"multiple":true,"group-values":"grades","group-label":"group","group-select":true,"placeholder":"Select grade level","track-by":"grade","label":"name"},on:{"input":_vm.update},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }